import { AppState } from './index.tx';
import { GamificationState } from './gamification-reducer';
import { createSelector } from '@ngrx/store';

export function getGamificationState(state: AppState): GamificationState {
  return state.shared && state.shared.gamification;
}

export const getGamificationProfileSelector = createSelector(
  getGamificationState,
  (state: GamificationState) => state && state.gamificationProfile
);

export const getLeaderboardStatusSelector = createSelector(
  getGamificationState,
  (state: GamificationState) => state && state.leaderboardStatus
);

export const getLeaderboardSelector = createSelector(
  getGamificationState,
  (state: GamificationState) => state && state.leaderboard
);

export const getWeeklyBadgesSelector = createSelector(
  getGamificationState,
  (state: GamificationState) => state && state.weeklyBadges
);



// WEBPACK FOOTER //
// ./ts/app/shared/reducers/gamification-selectors.ts